<template>
  <div class="main">
    <h2 class="title">标签<span>{{noteListData.tagType}}</span>下的文章</h2>
    <ul>
      <li class="blogItem" v-for="item in noteListData.tagData">
        <h2 class="blogTitle">{{item.caption}}</h2>
        <span class="blogUpTime">{{item.updatetime}}</span>
        <p class="blogIntro">{{item.intro}}</p>
        <a class="blogDetail" @click="$goRoute('noteItem',{noteData:item})">阅读全文»</a>
        <!--<a class="blogDetail" target="_blank" :href="item.url">阅读全文»</a>-->
      </li>
    </ul>

    <!--<h2 class="blogTitle">{{noteData.caption}}</h2>-->
    <!--<div v-html="html">{{noteData}}</div>-->
    <!--<iframe id="noteItemIfr" :src="noteListData.content" frameborder="0"></iframe>-->
  </div>
</template>

<script>
  export default {
    name: 'noteList',
    data() {
      return {
        noteListData: {}
      }
    },
    components: {},
    mounted: function () {
      // console.log(1,this.$route.params.noteListData)
      if (this.$route.params.noteListData){
        this.noteListData = this.$route.params.noteListData;
        sessionStorage.setItem('noteListCur',JSON.stringify(this.noteListData))
      }else{
        this.noteListData = JSON.parse(sessionStorage.getItem('noteListCur'));
      }

      // console.log(333,this);
      // document.getElementById('noteItemIfr').onload = function(){
      //   console.log(1)
      //   console.log($('#noteItemIfr').contents().find("#header"))
      //   console.log(2)
      //
      // };

    }
  }
</script>

<style lang="scss">
  .title{
    padding: 20px 30px;
    /*background-color: #f6f9fa;*/
    text-align: center;
    color: #999;
    font-size: 24px;
    font-weight: bold;
    span{
      color: #2479CC;
    }
  }
  .blogItem{
    position: relative;
    margin: 30px 0;
    .blogTitle{
      font-size: 32px;
      margin-bottom: 25px;
      /*font-weight: bold;*/
    }
    .blogUpTime{
      position: absolute;
      top: 10px;
      right: 0;
      color: #555;
    }
    .blogIntro{
      margin-bottom: 16px;
    }
    .blogDetail{
      color: #2479CC;
      cursor: pointer;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/module/noteList.vue